<template>
<div>
  <!-- <gemini-scrollbar class="sidebar-scrollbar" id="sidebar-scroll" :autoshow="true" > -->
    <div :class="{left_container:NoticList.length +bordList.length>5,left_container1:NoticList.length +bordList.length<=5}" @scroll="scrollEvent">
      <div v-if="NoticList.length != 0 || bordList.length != 0" ref="LoadMore" class="bbb">
        <!-- 公告 -->
         <div class="all_inner left_inner" v-for="item1 of bordList" :class="{grey_text:item1.isRead==1}" @click="routerUrlbrod(item1)" ref="LoadMore1">
          <h2>
            <span v-if="item1.publicDate">{{item1.publicDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}</span>
            <span class="pull-right">公告</span>
          </h2>
         <div :class="{grey_text:item1.isRead==1}" class="notice_inner" @click="changeText(item1)">
            <p><span v-if="item1.enable" style="font-size:14px;color:#f55353;">[置顶]</span><span style="font-weight:bold;">{{item1.title}}</span></p>
            <p :class="{grey_text:item1.isRead==1,overText11:item1.size>656}"    v-html="item1.photoId"></p>
          </div>         
        </div>

        <!-- 通知和告警 -->
        <div ref="LoadMore2" class="all_inner left_inner" v-for="(item,index2) of NoticList" :key="index2" :class="{grey_text:item.isRead==1 && item.statusType==1}" @click="routerUrl(item)">
          <h2 :class="{greyNot_text:item.dealStatus==3}">
            {{item.createDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}
            <span class="pull-right" v-if="item.statusType==0">{{item.monitoringType}}告警</span>
            <span class="pull-right" v-else-if="item.statusType==1">{{item.monitoringType}}离线</span>
            <span class="pull-right" v-else-if="item.statusType==2">{{item.monitoringType}}故障</span>

            <span class="pull-right" v-else-if="item.statusType==3&&item.type==3">超时</span>

            <span class="pull-right" v-else>通知</span>
          </h2>
          <div class="notice_inner" :class="{greyNot_text:item.dealStatus==3}" @click="changeText(item)" v-if="item.statusType!=3">
            {{item.monitoringCode}}<span class="separate">|</span>{{item.monitoringName}}<br/>
            {{item.detailAddress}}
          </div>
          <div class="notice_inner" @click="changeText(item)" v-if="item.statusType==3">
            <p v-if="item.type==0">您关于"{{item.monitoringName}}"设备的报警处理单已通过,再接再厉!</p>
            <p v-else-if="item.type==1">您收到一份关于"{{item.monitoringName}}"设备的报警处理单,请及时处理!</p>
            <p v-else-if="item.type==3&&item.statusType==3">您关于"{{item.monitoringName}}"设备的告警超时未处理,请及时处理!</p>
            <p v-else>您关于"{{item.monitoringName}}"设备的报警处理单被退回,请及时处理!</p>
          </div>   
          <template v-if="item.statusType==0">
            <div class="pull-left notic_type_line">
              <template v-if="item.dealStatus==0">
                <i>●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i>
              </template>
              <template v-if="item.dealStatus==1">
                <i>●</i><span></span>
                <i>●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i>
              </template>
              <template v-if="item.dealStatus==2">
                <i>●</i><span></span>
                <i>●</i><span></span>
                <i>●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i>
              </template>
              <template v-if="item.dealStatus==3">
                <i class="greyFont">●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i><span class="greyFont greyBg"></span>
                <i class="greyFont">●</i>
              </template>                                          
            </div>
            <div class="pull-left notic_type">
              <template v-if="item.dealStatus==0">
                <span>待处理</span>
                <span class="greyFont">处理中</span>
                <span class="greyFont">审核中</span>
                <span class="greyFont">已结束</span>
              </template>
              <template v-if="item.dealStatus==1">
                <span>待处理</span>
                <span>处理中</span>
                <span class="greyFont">审核中</span>
                <span class="greyFont">已结束</span>
              </template>  
              <template v-if="item.dealStatus==2">
                <span>待处理</span>
                <span>处理中</span>
                <span>审核中</span>
                <span class="greyFont">已结束</span>
              </template>
              <template v-if="item.dealStatus==3">
                <span class="greyFont">待处理</span>
                <span class="greyFont">处理中</span>
                <span class="greyFont">审核中</span>
                <span class="greyFont">已结束</span>
              </template>                                         
            </div>
          </template>
        </div>
        </div>
      <div v-else class="No">
        <img src="../../../static/img/Nomessage.png">
        <span style="color:#f5f5f5;">暂无消息</span>
      </div>
      <div v-show="showState">
        <div class="text-center greyFont is_bottom" v-if="finish">
          <span>————————</span><span>我是有底线的</span><span>————————</span>
        </div>
        <div class="text-center" v-else-if="loading">
          <span><img src="../../assets/img/loading.gif" alt=""/></span>
        </div>
      </div>
    </div>
    <!-- </gemini-scrollbar> -->
<el-dialog
  top='0'
  :showClose="false"
  :visible.sync="dialogVisible"
   width="60%"
   height="calc(100%)"
   class="board">
  <div class="boardTitle"> 
    <div>{{noticeDetails.title}}</div>
    <div>发布时间：{{noticeDetails.publicDate}}</div>
  </div>
  <!-- <div class="boardTxt" v-html="noticeDetails.content">
  </div> -->

  <div class="ql-container ql-snow" style="border:none;">
      <div class="ql-editor" v-html="noticeDetails.content">
      </div>
  </div>
</el-dialog>
</div>  
</template>

<script>
import {ajaxFuncJson} from '@/api/ajax';
import { parseTime } from '@/utils';
// import refresh from '@/components/refresh';//上拉加载组件

export default {
  components: {
    // refresh,//注册上拉加载组件
  },
  //接收父组件websocket推送通知
  props: {
     NoticList1:{
          type:Array,
          default:[]
     }, 
     currentPage1:{
          type:Number,
          default:1
     },          
  },    
  name: 'left',
  data () {
    return {
      noticeDetails:{},
      dialogVisible:false,
      bordList:[],
      NoticList:this.NoticList1,//通知栏列表
      currentPage:this.currentPage1,//通知栏列表当前页
      pageSize:10, //通知栏列表显示页码
      isKaiGuan:true,
      finish:false,
      showState:true,
      loading:false,
      deviceType:'',
    }
  },   
  created() {
    this.getBrodList(); //获取公告列表信息
    this.getNoticList(); //获取通知栏列表信息
  }, 
  watch: {
      NoticList1(newValue, oldValue) { //监听父组件传过来的websocket推送信息
        if(newValue.length != 0){
          newValue.forEach((a,b)=>{
            switch(a.monitoringType) {
                  case 1:
                      a.monitoringType = '电气';
                      break;
                  case 2:
                      a.monitoringType = '水压';
                      break;
                  case 3:
                      a.monitoringType = '液位';
                      break;
                  case 4:
                      a.monitoringType = '可燃气';
                      break;
                  case 5:
                      a.monitoringType = '烟感';
                      break;
                  case 6:
                      a.monitoringType = '灭火瓶';
                      break;
                  default:
              } 
          })

        }         
        this.NoticList=newValue
      },           
      currentPage1(newValue, oldValue){
        this.currentPage=newValue
      }  
  },
  methods:{
    changeText(item){ //查看过通知文字颜色变灰
      let params={
        noticeId:item.id,
      }      
      ajaxFuncJson('/alarmNoticeRecord/readNotice',params).then(res=>{
        let Data = res.data.data
            item.isRead=1
      });      
    },
    getScrollTop() { //滚动条在Y轴上的滚动距离
      var scrollTop = 0,
        bodyScrollTop = 0;
      if (document.getElementsByClassName('left_container')[0]) {
        bodyScrollTop = document.getElementsByClassName('left_container')[0].scrollTop;
      }
      scrollTop =bodyScrollTop;
      return scrollTop;
    },
    getScrollHeight() { //文档的总高度
      var scrollHeight = 0,
        bodyScrollHeight = 0;
      if (document.getElementsByClassName('left_container')[0]) {
        bodyScrollHeight = document.getElementsByClassName('left_container')[0].scrollHeight;
      }
      scrollHeight = bodyScrollHeight;
      return scrollHeight;
    },
    getWindowHeight() { //文档视口的高度
      var windowHeight = 0;
      windowHeight = document.getElementsByClassName('left_container')[0].clientHeight;
      return windowHeight;
    },
    scrollEvent(){
      this.menu();
    },
    menu() {
      if(this.isKaiGuan){
        let scroll = this.getScrollTop() + this.getWindowHeight() - this.getScrollHeight();
        if (scroll > -60) {
          this.currentPage++;
          this.loading=true;
          this.getNoticList();
          this.isKaiGuan=false;
        }
      }
    },
    routerUrl(item){ //路由跳转
      if(item.statusType==3){
        if(item.type==0){
          sessionStorage.setItem('saveId',item.monitoringId);
          this.$router.push({path:'/content/searchForm',query:{searchUrl:'3-1',id:item.alarmDealRecordId,deviceType:this.monitorType(item.monitoringType)}});
        }else if(item.type==1){
          sessionStorage.setItem('saveId',item.monitoringId);
          this.$router.push({path:'/content/searchForm',query:{searchUrl:'2-1',id:item.alarmDealRecordId,deviceType:this.monitorType(item.monitoringType)}});
        }else if(item.type==2){
          sessionStorage.setItem('dealStatus',item.dealStatus);
          sessionStorage.setItem('saveId',item.monitoringId);
          this.$router.push({path:'/content/searchForm',query:{id:item.alarmDealRecordId,deviceType:this.monitorType(item.monitoringType),type:'warnData'}});
        }
      }else {
        sessionStorage.setItem('saveId',item.monitoringId);
          // 进入监控详情页面
          if(this.isAuth('common:interface')){
              this.$router.push({path:'/content/monitorDetails'})
          }
      }
    },
    routerUrlbrod(item){ //五期公告详情
      ajaxFuncJson('/notice/findNoticeById',{id:item.id}).then(res=>{ 
          if(res.data.status==200){
            this.noticeDetails = res.data.data;
          }
      }); 
        this.dialogVisible = true;
    },
    monitorType(value){
      switch(value) {
        case '电气':
          this.deviceType = 1;
          break;
        case '水压':
          this.deviceType = 2;
          break;
        case '液位':
          this.deviceType = 3;
          break;
        case '可燃气':
          this.deviceType = 4;
          break;
        case '烟感':
          this.deviceType = 5;
          break;
        case '灭火瓶':
          this.deviceType = 6;
          break;
        default:
      }
      return this.deviceType;
    },
    //获取公告列表消息
    getBrodList(){
      ajaxFuncJson('/notice/getNoticeForUser',{currPage:1,pageSize:10}).then(res=>{ 
        if(res.data.status==200&&res.data.data.length>0){
          let Data = res.data.data;
          Data.forEach((list,index)=>{
            list.content = ((list.content).toString()).replace(/<img[^>]*>/g, "<span style='color:#198cff;'>[图片]</span>");
            if(list.photoId){
              this.$set(list,'size',this.textSize("13px","Arial",list.photoId).width);//给对象数组添加数据index
              list.photoId = ((list.photoId).toString()).replace(/\[图片\]/g, "<span class='span' style='color:#198cff;'>[图片]</span>");
              // if(list.photoId.length>=20){

              // }
            }
            
            // list.content = ((list.content).toString()).replace(/<p[^>]*>/g, "");
            // list.content = ((list.content).toString()).replace(/<\/p[^>]*>/g, "");
            // list.content = ((list.content).toString()).replace(/<span[^>]*>/g, "");
            // list.content = ((list.content).toString()).replace(/<\/span[^>]*>/g, "");
          })
          if(Data[0].topCount == 1){
             this.bordList = Data.slice(0, 2);
          }else if(Data[0].topCount == 2){
             this.bordList = Data.slice(0, 3);
          }else if(Data[0].topCount >=3){
             this.bordList = Data.slice(0, 4);
          }else{
           this.bordList = Data.slice(0, 1);
          }
        }
      }); 
    },
    //获取通知栏列表信息
    getNoticList(){
      let params={
        currentPage:this.currentPage,
        pageSize:this.pageSize,
      }
      ajaxFuncJson('/alarmNoticeRecord/getNoticList',params).then(res=>{ 
        if(res.data.status==200&&res.data.data.length>0){
          if(res.data.data.length<10){
            this.isKaiGuan=false;
            this.finish=true;
          }else {
            this.isKaiGuan=true;
          }
          this.loading=false;
          res.data.data.forEach((item, index) => { 
            this.NoticList.push(item)
          });          
        }
      });      
    }, 
    // 加载更多
    onScrollBottom () { 
      this.currentPage++     
      this.getNoticList();
    },        
    
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$cyan:#00fcc9;
$grey:#8e8e8e;
.left_container1{
  height: 770px;
  overflow: hidden;
}
.left_container1::-webkit-scrollbar{/*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width:4px;
}
.left_container1::-webkit-scrollbar-button{/*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  display:none
}
.left_container1::-webkit-scrollbar-track{/*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  display:none
}
.left_container1::-webkit-scrollbar-track-piece{/*内层轨道，滚动条中间部分（位置4）*/
  background:rgba(0,0,0,.3);
}
.left_container1::-webkit-scrollbar-thumb{/*滚动条里面可以拖动的那部分（位置5）*/
  background:#4e4e4e;
  border-radius:4px;
}
.left_container1::-webkit-scrollbar-corner {/*边角（位置6）*/
  background:#82AFFF;
}
.left_container1::-webkit-scrollbar-resizer  {/*定义右下角拖动块的样式（位置7）*/
  background:#FF0BEE;
}
.left_container1 {
  scrollbar-width: thin;
}
.left_container1{
  scrollbar-arrow-color: #f4ae21; /**//*三角箭头的颜色*/
  scrollbar-face-color: #333; /**//*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**//*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**//*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**//*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**//*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**//*立体滚动条背景颜色*/
  scrollbar-base-color:#f8f8f8; /**//*滚动条的基本颜色*/
}







.left_container{
  height: 770px;
  overflow: hidden;
  &:hover{
   overflow-y: auto;
  &>div{
    margin-right:-4px;
  }
  }
}
.left_container::-webkit-scrollbar{/*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width:4px;
}
.left_container::-webkit-scrollbar-button{/*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  display:none
}
.left_container::-webkit-scrollbar-track{/*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  display:none
}
.left_container::-webkit-scrollbar-track-piece{/*内层轨道，滚动条中间部分（位置4）*/
  background:rgba(0,0,0,.3);
}
.left_container::-webkit-scrollbar-thumb{/*滚动条里面可以拖动的那部分（位置5）*/
  background:#4e4e4e;
  border-radius:4px;
}
.left_container::-webkit-scrollbar-corner {/*边角（位置6）*/
  background:#82AFFF;
}
.left_container::-webkit-scrollbar-resizer  {/*定义右下角拖动块的样式（位置7）*/
  background:#FF0BEE;
}
.left_container {
  scrollbar-width: thin;
}
.left_container{
  scrollbar-arrow-color: #f4ae21; /**//*三角箭头的颜色*/
  scrollbar-face-color: #333; /**//*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**//*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**//*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**//*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**//*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**//*立体滚动条背景颜色*/
  scrollbar-base-color:#f8f8f8; /**//*滚动条的基本颜色*/
}
.left_inner{
	height: auto;
  min-height: 108px;
  cursor: pointer;
	h2{
		font-weight: normal;
	}
	.notice_inner{
		color: $cyan !important;
		padding: 14px 0;
    line-height: 25px;
    font-size: 13px;
    .separate{
      margin: 0 10px;
    }
  }
  .notic_type_line{
    padding: 0 10px;
    text-align: left;
    i{
      font-style: normal;
      color: $cyan;
      float: left;
      font-size: 14px;
      margin-left: -2px;
    }
    span{
      float: left;
      width: 88px;
      height: 2px;
      background: $cyan;
      margin-top: 9px;
      margin-left: -1px;
    }
  }
	.notic_type{
    margin-bottom: 14px;
    font-size: 14px;
    span{
      color: $cyan;
      margin-right: 40px;
      &:last-child{
        margin-right: 0;
      }
    }
  } 
	
}
.grey_text{
	h2{		
		color: $grey !important;
	}
	.notice_inner{
		color: $grey !important;
	}		
}
.greyFont{
  color: $grey!important;
}
.greyBg{
  background: $grey!important;
}

.greyNot_text{
  color: $grey !important;	
}
// 滚动条样式
.sidebar-scrollbar {
    position: relative;
    height:770px;
    overflow: auto;
  }
  
.sidebar-content {
   padding: 1.5rem 1.5rem .5rem;
}

@media screen and (max-width: 1366px) {
  .left_container{
    height: 620px;
  }
  .sidebar-scrollbar {
    position: relative;
    height:590px;
    overflow: auto;
  }  
}

</style>



// WEBPACK FOOTER //
// src/page/home/left.vue